import React from "react";
import { MessageCircle, Camera, Mail } from "lucide-react";

export default function Footer() {
    return (
        <footer className="font-nunito bg-gradient-to-br from-[#4a3b7a] via-[#6C5C94] to-[#a06080] text-white/90 py-10 px-4 md:px-6">
            <div className="max-w-[1100px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4 pb-6 border-b border-white/15">
                {/* Brand */}
                <div className="text-center md:text-left">
                    <span className="text-xl font-extrabold text-white tracking-tight">
                        🐾 Smart<span className="text-[#f7c3dc]">Pet</span>
                    </span>
                    <p className="text-sm text-white/65 font-semibold mt-0.5">
                        Tecnología con corazón — Chajarí, Entre Ríos
                    </p>
                </div>

                {/* Social Icons */}
                <div className="flex gap-3">
                    <a
                        href="https://wa.me/+5493412275598"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="WhatsApp"
                        className="w-11 h-11 rounded-full bg-white/10 border border-white/25 flex items-center justify-center text-white text-lg transition hover:bg-white/25 hover:border-white/50 hover:-translate-y-0.5"
                    >
                        <MessageCircle size={20} />
                    </a>
                    <a
                        href="https://www.instagram.com/tagsmartpet/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        className="w-11 h-11 rounded-full bg-white/10 border border-white/25 flex items-center justify-center text-white text-lg transition hover:bg-white/25 hover:border-white/50 hover:-translate-y-0.5"
                    >
                        <Camera size={20} />
                    </a>
                    <a
                        href="mailto:juanmatoniolo2@gmail.com"
                        aria-label="Email"
                        className="w-11 h-11 rounded-full bg-white/10 border border-white/25 flex items-center justify-center text-white text-lg transition hover:bg-white/25 hover:border-white/50 hover:-translate-y-0.5"
                    >
                        <Mail size={20} />
                    </a>
                </div>
            </div>

            {/* Bottom */}
            <div className="max-w-[1100px] mx-auto mt-5 text-center text-sm text-white/40 font-semibold">
                © 2025 SmartPet — Diseñado y desarrollado por{" "}
                <a
                    href="https://www.instagram.com/juanmatoniolo/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/70 hover:text-white underline underline-offset-2 transition"
                >
                    Juanma Toniolo
                </a>
            </div>
        </footer>
    );
}